import React from 'react';
import { Modal, Typography } from 'antd';
import notFound from './../../../assets/images/not-found.png';

const { Text } = Typography;

type CustomModalProps = {
  isModalVisible: boolean;
};

const MobileWarningModal: React.FC<CustomModalProps> = ({ isModalVisible }) => {
  return (
    <Modal
      visible={isModalVisible}
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
      footer={null}
      bodyStyle={{ padding: 0 }}
      className="h-[60%] flex items-center justify-center isModalVisible"
    >
      <div className="h-[45vh] w-full bg-white/90 rounded-lg p-6  flex flex-col justify-center items-center text-center">
        <div className="mb-4">
          <img src={notFound} className="opacity-[.7]" alt="not found" width={120} />
        </div>
        <Text className="font-rubik"> Sorry, <strong>All-Aboard!</strong> is not yet optimized for mobile devices.
          Please use a desktop to log in. Thank you for your understanding!</Text>
      </div>
    </Modal>
  );
};

export default MobileWarningModal;
